<div *ngIf="showBanner == true" aria-modal="true" class="cookie-banner-backdrop" role="dialog">
  <div class="cookie-banner">
    @if (showManagePreference == false) {
      <!-- Close button -->
      <button aria-label="Close" class="cookie-close-btn" (click)="onClose()">×</button>
      <!-- Icon + Title -->
      <div class="cookie-header">
        <div class="cookie-icon">
          <i class="fa-solid fa-user-lock text-brand-primary-100"></i>
        </div>
        <h2>{{ 'cookie_banner.cookie_title' | translate }}</h2>
      </div>

      <!-- Body text -->
      <p class="cookie-text">
        {{ 'cookie_banner.cookie_description' | translate }}
      </p>

      <!-- What we use the data for -->
      <div class="cookie-list">
        <h3>{{ 'cookie_banner.usage_reason.title' | translate }}</h3>
        <ul>
          <li>
            <i class="fa-solid fa-circle-check text-brand-primary-100"></i>
            <span>{{ 'cookie_banner.usage_reason.improve_performance' | translate }}</span>
          </li>
          <li>
            <i class="fa-solid fa-circle-check text-brand-primary-100"></i>
            <span>{{ 'cookie_banner.usage_reason.bug_fix' | translate }}</span>
          </li>
        </ul>
      </div>
      <div style="margin-bottom: 15px; margin-top: 25px">
        <span>{{ 'cookie_banner.read_about_cookie' | translate }}</span>
        <a class="text-info-101" href="https://xfarm.ag/en/cookie-policy" target="_blank">
          Cookie policy
          <i class="fa-solid fa-arrow-up-right" style="margin-left: 2px"></i>
        </a>
      </div>
      <hr />
      <!-- Buttons -->
      <div class="cookie-buttons">
        <button class="btn-manage" (click)="managePreferences()">
          {{ 'cookie_banner.button.manage_preferences' | translate }}
        </button>
        <button class="btn-accept" (click)="acceptAll()">
          {{ 'cookie_banner.button.accept_all' | translate }}
        </button>
      </div>
    } @else {
      <div class="cookie-header">
        <button aria-label="Back" class="cookie-back-btn" (click)="goBack()">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <h2>{{ 'cookie_banner.manage_preferences_title' | translate }}</h2>
      </div>

      <p class="cookie-description">
        {{ 'cookie_banner.manage_preferences_description' | translate }}
      </p>

      <div class="cookie-settings">
        <h3>{{ 'cookie_banner.consent_settings.title' | translate }}</h3>

        <div class="cookie-option">
          <div class="cookie-option-text">
            <strong>{{ 'cookie_banner.consent_settings.strictly_necessary' | translate }}</strong>
          </div>
          <label class="switch disabled">
            <input checked disabled type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>
        <p style="margin-bottom: 15px">
          {{ 'cookie_banner.consent_settings.strictly_necessary_description' | translate }}
        </p>

        <div class="cookie-option">
          <div class="cookie-option-text">
            <strong>{{ 'cookie_banner.consent_settings.analytics' | translate }}</strong>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="consent.analytics" />
            <span class="slider round"></span>
          </label>
        </div>
        <p style="margin-bottom: 15px">
          {{ 'cookie_banner.consent_settings.analytics_description' | translate }}
        </p>

        <div class="cookie-option">
          <div class="cookie-option-text">
            <strong>
              {{ 'cookie_banner.consent_settings.marketing_personalization' | translate }}
            </strong>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="consent.marketing" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <p style="margin-bottom: 15px">
        {{ 'cookie_banner.consent_settings.marketing_personalization_description' | translate }}
      </p>
      <hr />
      <div class="cookie-buttons">
        <button class="btn-manage" (click)="acceptSelected()">
          {{ 'cookie_banner.button.accept_selected' | translate }}
        </button>
        <button class="btn-accept" (click)="acceptAll()">
          {{ 'cookie_banner.button.accept_all' | translate }}
        </button>
      </div>
    }
  </div>
</div>
